module.exports = __webpack_public_path__ + "img/36_75.893c0eee.png";